import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
  taskNumber: number;
}


@Component({
  selector: 'app-limit-exceded-popup',
  templateUrl: './limit-exceded-popup.component.html'
})
export class LimitExcededPopupComponent {
  constructor(public dialogRef: MatDialogRef<LimitExcededPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  closePopup(): void {
    this.dialogRef.close();
  }
}
